"use client";

import React from "react";
import { ArrowRight, CircleCheck, ClipboardList, HardHat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceContinuity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="servicecontinuity" className="bg-primary text-primary-foreground relative overflow-hidden ![padding:60px_0px_60px_0px] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/02/abstract-meeting-widescreen.webp)]">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-accent/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-secondary/5 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="order-2 lg:order-1 flex justify-center lg:justify-start relative">
            <div className="absolute inset-0 bg-accent/10 blur-3xl rounded-full w-3/4 h-3/4 m-auto" />
            
            <div className="relative z-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-8">
              {}
              <div className="flex flex-col items-center gap-4">
                <div className="bg-background/10 p-6 rounded-2xl backdrop-blur-md border border-background/20 shadow-xl">
                  <ClipboardList className="w-12 h-12 text-accent" strokeWidth={1.5} />
                </div>
                <span className="text-sm font-medium text-primary-foreground/80 tracking-wide uppercase">
                  Audit Énergétique
                </span>
              </div>

              {}
              <div className="hidden sm:flex flex-col items-center justify-center">
                <div className="h-px w-16 bg-gradient-to-r from-transparent via-accent/50 to-transparent mb-2" />
                <ArrowRight className="w-8 h-8 text-accent/70" />
              </div>
              <div className="sm:hidden flex items-center justify-center rotate-90 my-2">
                <ArrowRight className="w-8 h-8 text-accent/70" />
              </div>

              {}
              <div className="flex flex-col items-center gap-4">
                <div className="bg-background/10 p-6 rounded-2xl backdrop-blur-md border border-background/20 shadow-xl">
                  <HardHat className="w-12 h-12 text-accent" strokeWidth={1.5} />
                </div>
                <span className="text-sm font-medium text-primary-foreground/80 tracking-wide uppercase">
                  Maîtrise d'Œuvre
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-primary-foreground">Et après l'audit ? NSDB vous accompagne dans la réalisation des travaux !</h2>
              <p className="text-lg md:text-xl text-primary-foreground/80 leading-relaxed">Votre projet ne s'arrête pas à l'audit énergétique, et nous sommes prêts pour les étapes suivantes. Les recommandations de votre audit prennent alors vie grâce à notre expertise en Maîtrise d'œuvre.</p>
            </div>

            <ul className="space-y-4">
              {["Sans perte d'information ni changement d'interlocuteur", "Coordination complète des artisans qualifiés", "Suivi rigoureux du chantier et des délais", "Réalisation des formalités administratives"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-accent shrink-0 mt-0.5" />
                  <span className="text-primary-foreground/90">{item}</span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 border-none shadow-lg shadow-accent/20 text-base px-8 h-14 rounded-xl w-full sm:w-auto">
                <Link to="/maitrise-d-oeuvre">
                  Confier vos travaux à NSDB
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}